import type * as React from 'react';
import { Card, CardContent } from './ui/card';
import { InteractiveChartHint } from './charts/InteractiveChartHint';

export function Section({
  title,
  hint,
  badge,
  children,
  testId,
}: {
  title: string;
  hint?: boolean;
  /** A totals badge for the header, the timeline pattern (TimelineTotalsBadge). */
  badge?: React.ReactNode;
  children: React.ReactNode;
  testId: string;
}): React.ReactElement {
  return (
    <Card data-testid={testId}>
      <CardContent className="p-4 space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <h2 className="text-sm font-medium text-muted-foreground">{title}</h2>
          {hint && <InteractiveChartHint />}
          {badge && <div className="ml-auto">{badge}</div>}
        </div>
        {children}
      </CardContent>
    </Card>
  );
}
